import { textSizeToContentWidth } from '../../utility/index.js';

textSizeToContentWidth('.standout-text__title', '.standout-text__content');
